import { useState, useContext, useEffect, useCallback } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { HueContext } from '../HueContext';
import { useNavigate } from 'react-router-dom';

export default function Banking() {
  const navigate = useNavigate();
  const hue = useContext(HueContext);
   const [amount, setAmount] = useState("");
   const [relationship, setRelationship] = useState(null);
   const [error, setError] = useState("");
   const [linkToken, setLinkToken] = useState(null);
   const [submitting, setSubmitting] = useState(false);

  // Fetch a per-user Plaid link token from the server on mount
  useEffect(() => {
    const fetchLinkToken = async () => {
      try {
        const token = localStorage.getItem("spectraToken");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/plaid/create-link-token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await res.json();
        if (res.ok) setLinkToken(data.link_token);
      } catch (err) {
        console.error("Failed to get Plaid link token:", err);
      }
    };
    fetchLinkToken();
  }, []);

  // Called by Plaid Link after the user successfully connects their bank
  // public_token and account details stay on the server — frontend only receives the ACH relationship ID
  const handlePlaidSuccess = useCallback(async (public_token, metadata) => {
    try {
      setError("");
      const account_id = metadata.accounts[0]?.id;
      const token = localStorage.getItem("spectraToken");

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/plaid/exchange-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ public_token, account_id })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      setRelationship(data.relationship);
      const currentUser = localStorage.getItem("spectraUser");
      if (currentUser) {
        localStorage.setItem(`bankLinked_${currentUser}`, "true");
      }
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: handlePlaidSuccess
  });


const createTransaction = (type, amount) => {
  try {
    const existing = JSON.parse(localStorage.getItem("spectraTransactions") || "[]");
    existing.unshift({
      id: Date.now(),
      date: new Date().toISOString().split("T")[0],
      type,
      amount: parseFloat(amount)
    });
    localStorage.setItem("spectraTransactions", JSON.stringify(existing));
    window.dispatchEvent(new Event("transactionsUpdated"));
  } catch (err) {
    console.error("Transaction logging failed:", err);
  }
};



const handleDeposit = async () => {
  if (submitting) return;
  try {
    setError("");
    if (!relationship) {
      setError("Please link a bank account first.");
      return;
    }

    setSubmitting(true);
    const token = localStorage.getItem("spectraToken");
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/bank/deposit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
  amount,
  relationship_id: relationship.id,
  idempotencyKey: crypto.randomUUID()
})
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error);
    }

    alert("Deposit started");

await createTransaction("Deposit", amount);

  } catch (err) {
    setError(err.message);
  } finally {
    setSubmitting(false);
  }
};



    const handleWithdraw = async () => {
  if (submitting) return;
  try {
    setError("");
    if (!relationship) {
      setError("Please link a bank account first.");
      return;
    }

    setSubmitting(true);
    const token = localStorage.getItem("spectraToken");
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/bank/withdraw`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
        body: JSON.stringify({
        amount,
        relationship_id: relationship.id,
        idempotencyKey: crypto.randomUUID()
})
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error);
    }

     alert("Withdrawal started");

await createTransaction("Withdrawal", amount);

  } catch (err) {
    setError(err.message);
  } finally {
    setSubmitting(false);
  }
};


   const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "12px",
  borderRadius: "8px",
  border: "1px solid #333",
  background: "#111",
  color: "white",
  fontSize: "15px"
};

const primaryButton = {
  width: "100%",
  padding: "12px",
  background: "#ffd700",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"
};

const depositButton = {
  flex: 1,
  padding: "12px",
  background: "#1db954",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
};

const withdrawButton = {
  flex: 1,
  padding: "12px",
  background: "#d62828",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
};

  return (
  <div style={{ paddingTop: "60px" }}>
    
    <div
      style={{
        backgroundColor: "#000",
        color: "white",
        width: "450px",
        margin: "0 auto",
        padding: "30px",
        borderRadius: "16px",
        boxShadow: "0 12px 40px rgba(0,0,0,0.6)"
      }}
    >
      
      <h2
        style={{
          textAlign: "center",
          color: `hsl(${hue}, 100%, 60%)`,
          transition: "color 0.2s linear"
        }}
      >
        Banking
      </h2>

      {/* ---------------- Bank Section ---------------- */}

      {!relationship ? (
        <>
          <h4 style={{ marginTop: "20px" }}>Link Bank Account</h4>

          <button style={primaryButton} onClick={() => open()} disabled={!ready}>
            Link Bank with Plaid
          </button>

        </>
      ) : (
        <>
          <h4 style={{ marginTop: "20px" }}>Linked Bank</h4>
          <p>{relationship.nickname}</p>
          <p>****{relationship.last4}</p>
        </>
      )}

      {/* ---------------- Transfer Section ---------------- */}

      <div style={{ marginTop: "30px" }}>
        <h4>Transfer Funds</h4>

        <input
          type="number"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          style={inputStyle}
        />

        {error && <p style={{ color: "red" }}>{error}</p>}

        <div style={{ display: "flex", gap: "10px" }}>
          <button style={depositButton} onClick={handleDeposit} disabled={submitting}>
            Deposit
          </button>

          <button style={withdrawButton} onClick={handleWithdraw} disabled={submitting}>
            Withdraw
          </button>
        </div>
      </div>
    </div>
  </div>
);
}